import { render, staticRenderFns } from "./SideLink.vue?vue&type=template&id=6bbd9cfe&scoped=true"
import script from "./SideLink.vue?vue&type=script&lang=js"
export * from "./SideLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd9cfe",
  null
  
)

export default component.exports